/**
 * @fileoverview GET handler for the "/engagement/canvas/stats/:workflow_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementCanvasStatsWorkflowId } from "./constants";
import type { EngagementCanvasStatsWorkflowIdResult } from "./types";

export const getEngagementCanvasStatsWorkflowId = reactQueryFetcherAdapter(
  engagementCanvasStatsWorkflowId,
  (
    signal: AbortSignal,
    workflowId: string,
    start: number,
    end: number
  ): Promise<EngagementCanvasStatsWorkflowIdResult> => {
    return fetch(`/engagement/canvas/stats/${workflowId}`, "GET", { start, end }, { signal });
  }
);
